import { Language } from '../../../common/constants';

export class SetLanguage {
  public static readonly type = '[App] Set language';
  constructor(public payload: Language) {}
}

export class ToggleFullscreenMode {
  public static readonly type = '[App] Toggle fullscreen mode';
}
